import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fiscalFxRateSchema, fiscalFxRateListSchema, type FiscalFxRateInput } from '@erp/shared';
import { apiFetch } from '@/lib/api-client';
const path = '/api/v1/accounting/ledger/vat-rates';
const key = ['fiscal-fx-rates'] as const;
export function useFiscalRates(enabled = true) {
  return useQuery({
    queryKey: key,
    enabled,
    queryFn: () => apiFetch(path, fiscalFxRateListSchema),
  });
}
export function useReviewFiscalRate() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (body: FiscalFxRateInput) =>
      apiFetch(path, fiscalFxRateSchema, { method: 'POST', body }),
    onSuccess: () => client.invalidateQueries({ queryKey: key }),
  });
}
